export default {
    state: {
        arr: {}
    },
    getters:{
        KARD: state=> {
            return state.arr
        }
    },
    mutations: {
        SET_KARD: (state,payload) =>{
            state.arr=payload
            state.arr.actual='1'
        },
        SET_KARD_ACTUAL: (state,actual) =>{
            state.arr.actual=actual
        }
    },
    actions: {
        SET_KARD: (context, payload) => {
             context.commit('SET_KARD',payload)
        },
        SET_KARD_ACTUAL: (context, actual) => {
            context.commit('SET_KARD_ACTUAL',actual)
        }
    },

}